import * as m from 'mithril';

import WayPointFilterList from "./WayPointFilterList";
import { NavBar } from '../../components/NavBar';
import { MessageProvider } from '../../context/AppMessages';
import AppContext from '../../context/AppContext';
import buildLanguageChangeActions from '../common/LanguageNavActions';
import { getIntlStringValue } from '../../helpers/StringHelpers';
import CustomSvgIcon from '../../components/CustomSvgIcon';
import { DropOffOrderLineItemDTO, DropOffServiceOptionDTO, MoneyDTO } from '../../apiclient/ApiDtos';
import { formatMoney } from '../../helpers/MoneyFormatter';
import { Option, RadioGroup } from '../../components/BootstrapForm';

interface Attrs {
    appContext: AppContext,
    messageProvider: MessageProvider,
    title: string,
    maxSeatCount: number,
    totalNumberOfTravellers: number,
    currentEditingDropOffLineItem: DropOffOrderLineItemDTO | null,
    dropOffOptions: DropOffServiceOptionDTO[],

    onDropOffOrderLineItemAdded: (dropOffLineItem: DropOffOrderLineItemDTO) => void,
    onDropOffOrderLineItemUpdated: (newItem: DropOffOrderLineItemDTO, oldItem: DropOffOrderLineItemDTO) => void,
    onBack: () => void
}

export default function DropOffInformationFormPage(): m.Component<Attrs> {

    let selectedOption: DropOffServiceOptionDTO | null = null;
    let selectedNumberOfSeats: number | null = null;
    let address = "";

    let selectingOption = true;
    let showingAddressWarning = false;
    let showingSelectedNumberOfSeatsWarning = false;

    return {
        oninit(vnode) {
            console.log("Pickup form - oninit - editingItem:", vnode.attrs.currentEditingDropOffLineItem);

            if (vnode.attrs.currentEditingDropOffLineItem) {
                selectedOption = vnode.attrs.currentEditingDropOffLineItem.option;
                selectedNumberOfSeats = vnode.attrs.currentEditingDropOffLineItem.numberOfSeats;
                address = vnode.attrs.currentEditingDropOffLineItem.address;
            } else {
                //selectedNumberOfSeats = vnode.attrs.maxSeatCount;
                if (vnode.attrs.maxSeatCount == 1) {
                    selectedNumberOfSeats = 1;
                }
            }
            selectingOption = selectedOption == null;
        },
        view(vnode) {
            let { messageProvider } = vnode.attrs;
            let langChangeActionItems = buildLanguageChangeActions(vnode.attrs.appContext);
            let currentLang = messageProvider.getCurrentLang();

            let passengerCountOptions: Option[] = [];
            for (let i = 1; i <= vnode.attrs.maxSeatCount; i++) {
                passengerCountOptions.push({
                    label: String(i),
                    value: String(i),
                    description: (i == vnode.attrs.totalNumberOfTravellers && i != 1) ?
                        "(" + messageProvider.get("way_point_selection.all_travellers") + ")" : ""
                })
            }

            return [
                m('div', { class: 'app-layout bg' }, [
                    m(NavBar, {
                        title: vnode.attrs.title,
                        canBackPress: true,
                        onBackPressed: () => {
                            if (vnode.attrs.currentEditingDropOffLineItem == null && selectingOption) {
                                vnode.attrs.onBack();
                            } else if (vnode.attrs.currentEditingDropOffLineItem != null && !selectingOption) {
                                vnode.attrs.onBack();
                            } else {
                                selectingOption = !selectingOption;
                            }
                        },
                        actionItems: langChangeActionItems
                    }),
                    m("div.app-area-main",

                        selectingOption ?
                            m(WayPointFilterList, {
                                mode: "DROPOFF",
                                messageProvider: vnode.attrs.messageProvider,
                                wayPointOptions: vnode.attrs.dropOffOptions,
                                onWayPointSelected: (selectedWayPoint: DropOffServiceOptionDTO) => {
                                    selectedOption = selectedWayPoint;
                                    if (selectedWayPoint.mode == 'FIXED_POINT') {
                                        address = ""
                                    }
                                    selectingOption = false;
                                }
                            })
                            :


                            m("div.m-3",

                                m("div.d-flex justify-content-between",
                                    m("div.text-secondary mb-2",
                                        selectedOption?.mode == 'FIXED_POINT' ? messageProvider.get("common.gathering_point") : messageProvider.get("common.home_address_dropoff_location"),
                                    ),
                                    m("div.small font-weight-bold text-primary text-right text-end", {
                                        style: "min-width: 90px;",
                                        onclick: () => {
                                            selectingOption = true;
                                        }
                                    },
                                        messageProvider.get("to_reselect"),
                                        m(CustomSvgIcon, {
                                            iconType: "caret_arrow_right",
                                            themeCssClass: "svg-primary svg-small"
                                        })
                                    )
                                ),


                                m("div.d-flex_ _justify-content-between p-3 bg-white rounded shadow-sm", {
                                    onclick: () => {
                                        selectingOption = true;
                                    }
                                },

                                    m("div",
                                        m("div.font-weight-bold",
                                            selectedOption != null ? getIntlStringValue(selectedOption.name, currentLang)
                                                : ""
                                        ),
                                        (selectedOption != null) ?
                                            m("div.mt-1 small text-muted",
                                                (selectedOption.pricingMode ?? 'PER_SEAT') == 'PER_STOP' ?
                                                    null :
                                                    [
                                                        vnode.attrs.messageProvider.get("way_point_selection.one_person"), " ▹ "
                                                    ],
                                                m("span.text-success", formatMoney(selectedOption.unitFee))
                                            ) : ""
                                    ),
                                    /* m("div",
                                        m(CustomSvgIcon, {
                                            iconType: "caret_arrow_down",
                                            themeCssClass: "svg-info svg-small"
                                        })
                                    ) */
                                ),

                                selectedOption != null && selectedOption.mode == 'DOORSTEP' &&
                                m("div.",
                                    m("div.mt-4 text-secondary",
                                        messageProvider.get("way_point_selection.dropoff_location_details"),
                                        m("sup.ml-1 error", "*")
                                    ),
                                    m("textarea.form-control mt-1", {
                                        value: address,
                                        class: showingAddressWarning ? "border-danger" : "",
                                        oninput: (e: InputEvent) => {
                                            address = (e.target as HTMLTextAreaElement).value;
                                            showingAddressWarning = false;
                                        }
                                    })
                                ),

                                m("div.mt-4",
                                    {
                                        class: vnode.attrs.totalNumberOfTravellers == 1 ? "d-none" : ""
                                    },

                                    m("div", {
                                        style: showingSelectedNumberOfSeatsWarning ?
                                            "outline: 1px solid var(--danger); border-radius:5px; outline-offset: 5px" : ""
                                    },
                                        m(RadioGroup, {
                                            label: selectedOption?.mode == "FIXED_POINT" ? messageProvider.get("way_point_selection.number_of_travellers_to_fixpoint") : messageProvider.get("way_point_selection.number_of_travellers_to_dropoff_location"),
                                            name: "numPassengers",
                                            useBackground: true,
                                            lang: messageProvider.getCurrentLang(),
                                            options: passengerCountOptions,
                                            required: true,
                                            initialValue: (selectedNumberOfSeats != null) ? String(selectedNumberOfSeats) : null,
                                            //getCustomValidityMessage: (vs) => "Passengers required", //getIntlString(messageProvider, "validity.required_selection"),
                                            layout: "vertical",
                                            onValueChange: (newValue: string) => {
                                                selectedNumberOfSeats = parseInt(newValue);
                                                showingSelectedNumberOfSeatsWarning = false;

                                            },
                                            validityReportingAllowed: true,
                                            onInvalid: vs => {

                                            }
                                        })
                                    ),
                                ),

                                selectedOption?.mode == 'FIXED_POINT' &&
                                m("div.mt-4 ",
                                    m("div.rounded mt-2 p-3 small text-secondary", {
                                        style: "background-color: rgb(221, 226, 231) !important; color: #305C73 !important;"
                                    },
                                        m("div.text-info mb-3",
                                            messageProvider.get("common.gathering_point_description")
                                        ),
                                        m("div", {
                                            style: "line-height: 2rem;"
                                        },
                                            selectedOption.description ?
                                                messageProvider.getCurrentLang() == "en" ?
                                                    selectedOption.description.en ? selectedOption.description.en : m("span.text-muted", "-")
                                                    :
                                                    selectedOption.description.my ? selectedOption.description.my : m("span.text-muted", "-")
                                                :
                                                m("span.text-muted", "-")
                                        )
                                    )
                                )

                            )
                    ),

                    !selectingOption &&
                    m("div.app-area-footer",
                        m("div.p-2",
                            m("button.form-control btn btn-primary", {
                                onclick: () => {
                                    if (selectedOption != null) {
                                        if (selectedOption.mode == 'DOORSTEP' && address == "" || address == null) {
                                            showingAddressWarning = true;
                                            return;
                                        }

                                        if (!selectedNumberOfSeats) {
                                            showingSelectedNumberOfSeatsWarning = true;
                                            return;
                                        }

                                        let totalAmount: MoneyDTO = {
                                            amount: selectedNumberOfSeats * selectedOption.unitFee.amount,
                                            currency: selectedOption.unitFee.currency
                                        };
                                        let lineItem = {
                                            option: selectedOption,
                                            totalFee: totalAmount,
                                            numberOfSeats: selectedNumberOfSeats,
                                            address: address
                                        };

                                        if (vnode.attrs.currentEditingDropOffLineItem) {
                                            vnode.attrs.onDropOffOrderLineItemUpdated(lineItem, vnode.attrs.currentEditingDropOffLineItem);
                                        } else {
                                            vnode.attrs.onDropOffOrderLineItemAdded(lineItem);
                                        }
                                    }
                                }
                            }, "Done")
                        )
                    )
                ])

            ];
        }
    }
}